import React from "react";
import { ChevronRight, Trash2 } from "lucide-react";
import type { ArtifactSummary } from "@/api/client";

type ArtifactCardProps = {
  artifact: ArtifactSummary;
  onClick: () => void;
  onDelete: () => void;
};

export function ArtifactCard({ artifact, onClick, onDelete }: ArtifactCardProps) {
  const dateLabel = artifact.created_at
    ? new Date(artifact.created_at).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : null;

  return (
    <div className="flex w-full items-center gap-1 rounded-[12px] border border-[#E2E8F0] bg-[#F8FAFC] pl-4 pr-2 py-3 transition-colors hover:border-[#007AFF] hover:bg-[#EFF6FF]">
      <button
        type="button"
        onClick={onClick}
        className="flex flex-1 items-start gap-3 text-left min-w-0"
      >
        <div
          className={`mt-1 h-2 w-2 shrink-0 rounded-full ${
            artifact.status === "finalise" ? "bg-[#22C55E]" : "bg-[#F97316]"
          }`}
        />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <p className="truncate text-[14px] font-semibold leading-none text-[#0F172B]">
            {artifact.name}
          </p>
          <div className="flex items-center gap-2 text-[12px] text-[#45556C]">
            <span>{artifact.status === "finalise" ? "Finalisé" : "En cours"}</span>
            {artifact.has_audio && <span className="text-[#007AFF]">· Audio</span>}
            {artifact.has_video && <span className="text-[#007AFF]">· Vidéo</span>}
            {dateLabel && <span className="ml-auto shrink-0">{dateLabel}</span>}
          </div>
        </div>
        <ChevronRight className="mt-0.5 h-4 w-4 shrink-0 text-[#45556C]" />
      </button>
      <button
        type="button"
        onClick={onDelete}
        className="ml-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-[#94A3B8] transition-colors hover:bg-red-50 hover:text-red-500"
        aria-label="Supprimer l'artefact"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  );
}
